import React from "react";
import Pagetitle from "../components/elements/Pagetitle";
import Demo from "./Demo";

const demos1 = [
  {
    id: 1,
    title: "Combined",
    image: "images/demos/1-1.png",
    link: "/",
  },
  {
    id: 2,
    title: "Dark",
    image: "images/demos/1-2.png",
    link: "/dark",
  },
  {
    id: 3,
    title: "Light",
    image: "images/demos/1-3.png",
    link: "/light",
  },
];

const demos2 = [
  {
    id: 1,
    title: "Combined",
    image: "images/demos/2-1.png",
    link: "/index-2",
  },
  {
    id: 2,
    title: "Dark",
    image: "images/demos/2-2.png",
    link: "/index-2-dark",
  },
  {
    id: 3,
    title: "Light",
    image: "images/demos/2-3.png",
    link: "/index-2-light",
  },
];

const demos3 = [
  {
    id: 1,
    title: "Combined",
    image: "images/demos/3-1.png",
    link: "/index-3",
  },
  {
    id: 2,
    title: "Dark",
    image: "images/demos/3-2.png",
    link: "/index-3-dark",
  },
  {
    id: 3,
    title: "Light",
    image: "images/demos/3-3.png",
    link: "/index-3-light",
  },
];

function Demos() {
  return (
    <>
      <section>
        <div className="container">
          <Pagetitle title="Demo 1" />
          <div className="row">
            {demos1.map((demo) => (
              <div className="col-md-4" key={demo.id}>
                <Demo democontent={demo} />
                <div
                  className="spacer d-md-none d-lg-none"
                  data-height="30"
                ></div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section>
        <div className="container">
          <Pagetitle title="Demo 2" />
          <div className="row">
            {demos2.map((demo) => (
              <div className="col-md-4" key={demo.id}>
                <Demo democontent={demo} />
                <div
                  className="spacer d-md-none d-lg-none"
                  data-height="30"
                ></div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section>
        <div className="container">
          <Pagetitle title="Demo 3" />
          <div className="row">
            {demos3.map((demo) => (
              <div className="col-md-4" key={demo.id}>
                <Demo democontent={demo} />
                <div
                  className="spacer d-md-none d-lg-none"
                  data-height="30"
                ></div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <div className="spacer" data-height="96"></div>
    </>
  );
}

export default Demos;
